import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule }    from '@angular/forms';

/** AngularMaterial **/
import { MatCardModule, MatTabsModule, MatIconModule, MatButtonModule, MatToolbarModule } from '@angular/material';
import { EstudoDialogComponent } from './estudo-dialog.component';
import { EstudoDialogButtonComponent } from './estudo-dialog-button.component';
import { QuestionarioDinamicoModule } from 'unb-questionario-componente';
import { GrupoFamiliarModule } from '../grupo-familiar/grupo-familiar.module';

@NgModule({
    declarations: [
      EstudoDialogComponent, EstudoDialogButtonComponent
    ],
    exports: [
      EstudoDialogComponent, EstudoDialogButtonComponent
    ],
    imports: [
      FormsModule, CommonModule,
      QuestionarioDinamicoModule, GrupoFamiliarModule,
      MatCardModule, MatTabsModule, MatIconModule, MatButtonModule, MatToolbarModule
    ]
})
export class EstudoDialogModule {

}
